export const FETCH_USERS = 'users/FETCH_USERS';
export const TOGGLE_FETCHING_USERS = 'users/FETCHING_USERS';
export const ADD_USER = 'users/ADD_USER';
export const REMOVE_USER = 'users/REMOVE_USER';
export const REMOVE_USER_PROVIDER_MAPPING = 'users/REMOVE_USER_PROVIDER_MAPPING';




